var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange) {
    this.settings();

    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      lap: "(min-width: 1025px) and (max-width: 1279px)",
      desktop: "(min-width: 1280px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false);

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    const isDesktop = new Responsive().matchesBreakpoint("lap_and_up");
    if (isDesktop) {
        this.delegateRoot.on(
          "pswpTap",
          ".pswp__button--close",
          this.photoswiperClose.bind(this)
        );
    } else {
      this.delegateRoot.on(
        "click",
        ".pswp__button--close",
        this.photoswiperCloseMobile.bind(this)
      );
    }
  }

  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }

    bodyScrollLock.clearAllBodyScrollLocks();
  }

  photoswiperCloseMobile() {
    const mainContainer = document.querySelector(".pswp");
    if (!mainContainer) return;

    mainContainer.setAttribute("aria-hidden", "true");
    bodyScrollLock.clearAllBodyScrollLocks();

    setTimeout(() => {
      mainContainer.style.display = "none";
      document.body.classList.remove("iphone-pswp-fix");
    }, 300)
  }

  initPhotoSwipe() {
    var images = [],
    index = 0;

    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });

      index = this.slideshow.swiperElement.realIndex;
      index = this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }    

    const isDesktop = new Responsive().matchesBreakpoint("lap_and_up");
    if (isDesktop) {
      this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        parseInt(index)
      );
    } else {
      this.initMobileView(images, index);
    }

    const scroll = document.querySelector(".pswp__scroll-wrap");    
    if (scroll) bodyScrollLock.disableBodyScroll(scroll);
    
    document.body.classList.add("iphone-pswp-fix");
  }

  initMobileView(images, index) {
    function helper(i) {
      const tempItem = item.cloneNode(false);
      const currentImage = clonedImages[i];

      tempItem.style = `aspect-ratio: ${currentImage.dataset.aspectRatio}`;
      tempItem.classList.add("AspectRatio--PDP");
      tempItem.appendChild(currentImage);

      pswpContainer.appendChild(tempItem);
    }

    const clonedImages = images.map(image => {

      const newImage = image.cloneNode(false);
      const parent = image.parentElement; 
      const aspectRatio = getComputedStyle(parent).aspectRatio

      let src = newImage.src.split("width=")[0] + "width=1200";
      newImage.src = src;
      newImage.classList.add("pswp__img");
      newImage.dataset.aspectRatio = aspectRatio;      

      return newImage;
    })

    const mainContainer = document.querySelector(".pswp");
    const pswpContainer = mainContainer.querySelector(".pswp__container");
    pswpContainer.innerHTML = "";

    const item = document.createElement("div");
    item.classList.add("pswp__item");
    
    for (let i = index; i < clonedImages.length; i++) {
      helper(i)
    }

    for (let i = 0; i < index; i++) {
      helper(i)
    }

    mainContainer.style.display = "block";
    requestAnimationFrame(() => {
      mainContainer.setAttribute("aria-hidden", "false");
    })
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }

      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);

      let msrc = image.currentSrc || image.src;
      msrc = msrc.split('width=')[0] + "width=" + requestedWidth;

      return {
        msrc: msrc,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var photoswipeContainer = document.querySelector(".pswp");

    const options = this.createPhotoSwipeOptions(items, selectedImageIndex);

    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      options
    );

    this.bindPhotoSwipeEvents();

    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  createPhotoSwipeOptions(items, selectedImageIndex) {
    var _this = this;
    let options = {};

    options = {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        maxSpreadZoom: 10,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1.5 : 4;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      };

    return options;
  }

  bindPhotoSwipeEvents() {
    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains(
      "RevolutionSelectbox--Selectors"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("spesh")) {
      this.initSelectbox();
    }
  }

  bindEvents() {
    if (!this.element.classList.contains("spesh")) {
      this.onClickOutsideListener = this.onClickOutside.bind(this);
      this.domDelegate.on(
        "click",
        "[data-action=toggle-selectbox]",
        this.toggleDropdown.bind(this)
      );

      this.domDelegate.on(
        "click",
        "[data-action=selectbox-change]",
        this.selectboxChange.bind(this)
      );

      this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
      this.delegateBody.on("topbar:slideoff", this.onClickOutside.bind(this));
      this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
    }

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;
    if (!this.element.classList.contains("spesh")) {
      this.closeDropdown(this.element);
    }
    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
        '[selected="selected"]'
      ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      new Responsive().matchesBreakpoint("lap_and_up") &&
      this.headerTransparent
    ) {
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 1);
      setTimeout(() => {
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 601);
    }
    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;
    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });




    if (
      this.languageSelector &&
      new Responsive().matchesBreakpoint("lap_and_up")
    ) {
      if (contentElement.scrollHeight > contentElement.offsetHeight) {
        contentElement.style.scrollbarGutter = "stable";
      }
    }

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {

    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }

    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      new Responsive().matchesBreakpoint("lap_and_up") &&
      this.headerTransparent &&
      event.type != "menu:open" &&
      !event.target.classList.contains("searchItem") &&
      event.type != "close:search"
    ) {
      setTimeout(() => {
        document.body.querySelector("#header").toggleColor();
      }, 601);
    }
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 401);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=notify-me]",
      this.handleNotify.bind(this)
    );
  }

  destroy() {
    this.delegateElement.destroy();
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    var serialized = formHelper.serialize(formElement);

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            if (document.querySelector(".accent")) return;
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p3 accent ProductForm--Error";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton
              .closest("button")
              .insertAdjacentElement("afterend", errorMessageElement);
            _this.disableFunction = true;
            setTimeout(function () {
              errorMessageElement.remove();
              _this.disableFunction = false;
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
  handleNotify() {
    event.preventDefault();
    this.target = this.element.querySelector("button.SI_trigger");    
    this.target?.click();
  }

}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;


    switch (this.breakpoint) {
      case "lap_and_up":
        // For lap_and_up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "phone":
        // For phone breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
      case "tablet":
        // For tablet breakpoint, bind event for tablet dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem) {
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", "false");

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        DropdownContent.setAttribute("aria-hidden", "true");
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    //this.element.addEventListener("transitionend", transitionEnded);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}

new Dropdown();

class ReloadWhen1025 {
  constructor() {
    this.bodyDelegate = new Delegate(document.body);
    this.bindEvents();
  }

  bindEvents() {
    responsive.addBreakpointListener("lap_and_up");

    this.bodyDelegate.on("breakpoint:lap_and_up", (e) => {
      location.reload();
    });
  }
}

new ReloadWhen1025();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.favoriteOverlayElement = document.querySelector(".favorites-overlay");


      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {

    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
    this.element.style.height = window.innerHeight + "px";
    if (this.element.querySelector(".Drawer--Footer")) {
      const footerHeightDrawer =
        this.element.querySelector(".Drawer--Footer").offsetHeight;
      footerHeightDrawer.offsetHeight;
      if(this.element.querySelector(".Drawer--Wrapper")){
        this.element.querySelector(
          ".Drawer--Wrapper"
        ).style.height = `calc(100% - ${footerHeightDrawer}px)`;
      }

    }

    if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }



    if (this.isOpen) {
      return;
    }
    this.transitionEndHandler = (event) => this.handleTransitionEnd(event, 'open');
    this.element.addEventListener('transitionend', this.transitionEndHandler);
    this.element.classList.add('u-visible');
    this.element.classList.remove('u-hidden');
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );
    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    }
    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
    });

    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    if (this.element.getAttribute("id") == "favoritesDrawer") {
      this.favoriteOverlayElement.classList.add("is-visible");
      this.favoriteOverlayElement.addEventListener(
        "click",
        this._closeListener
      );
    }
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;

    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }


    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();


    this.element.setAttribute("aria-expanded", "false");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    this.favoriteOverlayElement.classList.remove("is-visible");
    this.favoriteOverlayElement.removeEventListener(
      "click",
      this._closeListener
    );
    this.transitionEndHandler = (event) => this.handleTransitionEnd(event, 'close');
    this.element.addEventListener('transitionend', this.transitionEndHandler);



    this.onClose();
  }

  handleTransitionEnd(event, direction) {
    if (direction === 'open') {
      trapFocus(this.element);
    } else {
      // Toggle visibility classes to hide the drawer
      this.element.classList.remove('u-visible');
      this.element.classList.add('u-hidden');

      // Update the state to indicate the drawer is closed
      removeTrapFocus(this.element);
      this.isOpen = false;
    }

    // Remove the transition end event listener
    this.element.removeEventListener('transitionend', this.transitionEndHandler);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
      addButtonInner = addButton.querySelector(".SelfAlign"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value();
    }
    let buySvg = "";
    if (window.variantInfo.show_icon) {
       buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } 

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
    let priceElement = "";
    if (window.variantInfo.show_price) {
       priceElement =
        "<span class='u-p3 ml-s'>" +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } 

    addButtonInner.innerHTML =
      buySvg + window.variantStrings.addToCart + priceElement;
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body);
    this.Drawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");

    if (this.options["showRecommendations"] || this.options["showRecommendations_empty"]) {
      this.loadRecommendations();
    }

    new AddToCart(this.element);
    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    this.domDelegate.on(
      "side-cart-variant:changed",
      this.updateImage.bind(this)
    );

    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on(
        "change",
        "[data-state='required']",
        this.toggleButton.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  updateImage(event) {
    if (event) {
      let ProductCardImage = event.target.querySelector(".ProductCard_Image");
      ProductCardImage.setAttribute("src", event.detail.new_image);
      ProductCardImage.setAttribute("srcset", event.detail.new_srcset);
    }
  }

  toggleButton() {
    this.buttonState = true;
    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    const button = this.element.querySelector(".cartCheckout--Button")

    if (this.buttonState == true) {
      button.removeAttribute("disabled");
    } else {
      button.setAttribute("disabled", true);
    }
  }

  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );
    }

  }
  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      _this.renderCart(target.getAttribute("data-id"), true);
      if (response.ok) {
        _this.element.dispatchEvent(
          new CustomEvent("product:changed", {
            bubbles: true,
            detail: target.getAttribute("data-id").match(/\d+/),
          })
        );
        localStorage.setItem(
          target.getAttribute("data-id").match(/\d+/),
          quantity
        );
      }
    });
  }

  onProductAdded(e) {
    var _this = this;
    if (e.detail.onlyRender) {
      this.disableScroll = false;
      this.renderCart();
    } else {
      this.disableScroll = true;
      this.renderCart().then(function () {
        _this.Drawer.openDrawer();
      });
    }
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    this.options = this.tempOptions;

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = number;
    window.theme.cartCount = parseInt(number);

    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);
      }

 

      if (
        this.options["showRecommendations"] ||
        this.options["showRecommendations_empty"]
      ) {
        this.loadRecommendations();
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartFooter--Buttons"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cartCheckout--Button"
        );
        
        checkoutButtonParent.replaceChild(
          checkoutButtonToReplace,
          checkoutButtonParent.querySelector(".cartCheckout--Button")
        );

        const footerTotalParent = this.element.querySelector(
          ".sidecart-footer_wrapper"
        );
        const footerTotalToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );

        if (footerTotalParent && footerTotalToReplace) {
          footerTotalParent.replaceChild(
            footerTotalToReplace,
            footerTotalParent.querySelector(".CartFooter--Totals")
          );
        }

        const checkboxes = this.element.querySelectorAll(
          ".terms-checkbox-container"
        );
        checkboxes.forEach((el) => (el.querySelector("input").checked = false));
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    }
    setTimeout(() => {
      if (
        (this.options["showRecommendations"] && !quantityChange) ||
        (this.options["showRecommendations_empty"] && !quantityChange)
      ) {
        this.loadRecommendations();
      }

      var focus = _this.element.querySelector("[data-scrollable]");
      if (this.disableScroll)
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.Drawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    var _this = this;
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          var z = container.querySelector(".cartUpsell").innerHTML;

          var x = _this.element.querySelector(".withItemRecommendations");
          if (x) {
            x.innerHTML = z;
          }

          const recommPresent = container.querySelector(".sidecart-recomm-item_card_wrapper");

          if (recommPresent)
            _this.element.querySelector(".CartDrawer--Recommendations")
              ? (_this.element.querySelector(
                  ".CartDrawer--Recommendations"
                ).style.display = "block")
              : null;
          else
            _this.element.querySelector(".CartDrawer--Recommendations")
              ? (_this.element.querySelector(
                  ".CartDrawer--Recommendations"
                ).style.display = "none")
              : null;

          const swiper = new Swiper(".swiperUpsell", {
            // Default parameters
            slidesPerView: 1,

            grid: {
              rows: 2, // your amount of slides
              fill: "row",
            },
            spaceBetween: 16,
            navigation: false,

            mousewheel: {
              forceToAxis: true,
            },
            loop: false,
            navigation: {
              nextEl: ".swiper-button__cart-next",
              prevEl: ".swiper-button__cart-prev",
            },
            breakpoints: {
              1025: {
                slidesPerView: 1,

                grid: {
                  rows: 2, // your amount of slides
                  fill: "row",
                },
                spaceBetween: 24,
              },
            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.carouselElementThumbs = this.element.querySelector(
      ".imageTxt--Thumbnails"
    );
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      if (this.options["show_thumbnails"]) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
        this.onImagesReady = this.createObserver.bind(this);
        this.element.addEventListener(
          "swiper:slide-changed",
          this.onImagesReady
        );
        this.createObserver();
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
        this.createObserver();
      }
    } else {
      this.createObserver();
    }

    this.delegateElement.on('click','[data-action="toggle-mute"]',this.toggleMute.bind(this));

    this.carousel = new RevolutionSwiper(this.carouselElement);

    
  }

  toggleMute(){
  
    const videoId = event.target.closest('.Banner__Cell').querySelector('.video-js').id;
    const video = videojs(videoId);


    if(video.muted()){

      video.muted(false);
      event.target.querySelector('.volume-up').style.display = 'block';
      event.target.querySelector('.volume-mute').style.display = 'none';
    } else {
      video.muted(true);
      event.target.querySelector('.volume-up').style.display = 'none';
      event.target.querySelector('.volume-mute').style.display = 'block';
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.3,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    const _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".Banner__Image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".Banner__Image");
      }
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace(
      "{width}x",
      "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    this.logoWrapper = this.element.querySelector(".header--LogoWrapper");
    document.addEventListener("product:added", this.onProductAdded.bind(this));


    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
      this.toggleScrollUp();
    }

    this.alphabeticalOrder();
    this.toggleColor();
    this.updateVisibleHeight();
    this.bindEvents();
    this.menuOverlapHandler();
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      this.element.clientHeight + "px"
    );
    if (this.options.transparent) {
      this.delegateBody.on(
        "header:transparent",
        (e) => {
          !e.detail
            ? this.element.classList.remove("Header--Transparent")
            : setTimeout(
                () => this.element.classList.add("Header--Transparent"),
                330
              );
        },
        true
      );
    }

  

  }

  onProductAdded() {    
    // Fetch najnoviji cart podatak
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            window.theme.cartCount = cart.item_count; // Ažuriraj globalni broj itema
            this.cartCount = document.querySelector(".CartCount");
            if (this.cartCount) {
                this.cartCount.innerHTML = window.theme.cartCount;
            }
        })
        .catch(error => console.error('Greška pri osvežavanju korpe:', error));
    }


  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcementBar with the visible height

    document.documentElement.style.setProperty(
      "--header-height-dynamic",
      `${visibleHeight}px`
    );
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
    this.element.parentElement.classList.add("header--StickyTop");
  }

  toggleScrollUp() {
    let lastScrollTop = 0;
    if (!document.querySelector(".Banner__Slideshow")) {
      return;
    }
    const heightOfBanner =
      document.querySelector(".Banner__Slideshow").offsetHeight;

    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop && scrollTop > heightOfBanner) {
        this.element.parentElement.classList.remove("header--StickyTop");
      } else {
        this.element.parentElement.classList.add("header--StickyTop");
      }

      lastScrollTop = scrollTop;
    });
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener("scroll", this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this),
      true
    );

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));

    this.delegateElement.on(
      "mouseover",
      '[data-action="toggle-image"]',
      this.changeImage.bind(this)
    );
    this.delegateElement.on(
      "mouseout",
      '[data-action="toggle-image"]',
      this.removeImage.bind(this)
    );

  }

  

  removeImage() {
    let imageWrapper = this.element.querySelector("[data-images_available]");
    let activeImage = imageWrapper.dataset.default;

    this.element.querySelector(".changeImage").remove();
    const img = document.createElement("img");
    img.src = activeImage;
    img.classList.add("changeImage");
    this.element.querySelector(".changeImage-box").append(img);
  }

  alphabeticalOrder() {
    const selectorsWrapper = this.element.querySelector(".RevolutionSelectbox--InnerContent");

    if (!selectorsWrapper) {
        console.error("selectorsWrapper not found");
        return;
    }

    const items = Array.from(selectorsWrapper.children);

    items.sort((a, b) => {
        const textA = a.textContent.trim().toLowerCase();
        const textB = b.textContent.trim().toLowerCase();
        return textA.localeCompare(textB);
    });

    selectorsWrapper.innerHtml = "";

    items.forEach(item => selectorsWrapper.appendChild(item));
}

  changeImage(event) {
    let activeImage = event.target.getAttribute("data-src");

    if (!activeImage) return;

    this.element.querySelector(".changeImage").remove();
    const img = document.createElement("img");
    img.src = activeImage;
    img.classList.add("changeImage");
    this.element.querySelector(".changeImage-box").append(img);
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight - 1}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    const related = event.relatedTarget;
    if (related && target.contains(related)) {
      return;
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    const dropdown_content = this.element.querySelectorAll(".Dropdown--Content");
    if(allOpen && dropdown_content){
      allOpen.forEach( (item) => {
          item.setAttribute("aria-expanded", "false");
     
      });
      dropdown_content.forEach((item) => {

        setTimeout(() => {        item.setAttribute("aria-hidden", "true");   item.style.height = "0px";       }, 350);

      })
    }
    if(!this.isCursorInHeader){

    this.toggleColor();
    }

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    const isHoveringHeader = this.element.matches(':hover');
    const isHoveringSubmenu = document.querySelector('.desktop-menu_dropdown')?.matches(':hover');

    if (isHoveringHeader || isHoveringSubmenu) {
      return; // don't run toggleColor if user is still interacting
    }

    let heightOfBanner = 0;
    if (document.querySelector("banner-hero")) {
      heightOfBanner = document.querySelector("banner-hero").offsetHeight;
    }

    if (window.scrollY > 25) {
      this.element.classList.add("Header--ScrolledBanner");
      if (new Responsive().getCurrentBreakpoint() === "desktop" && this.element.querySelector('.RevolutionSelectbox--Content[aria-hidden="false"]')) {this.element.dispatchEvent(new CustomEvent("topbar:slideoff", { bubbles: true }));}
      setTimeout(() => {
        if (this.logoWrapper && this.headerTransparent) {
          this.logoWrapper.style.pointerEvents = "initial";
        }
      }, 250);

    } else {
      this.element.classList.remove("Header--ScrolledBanner");
      setTimeout(() => {
        if (this.logoWrapper && this.headerTransparent) {
          this.logoWrapper.style.pointerEvents = "none";
        }
      }, 250);
    }
    if (window.scrollY > heightOfBanner) {
    
      this.element.classList.add("Header--Scrolled");
      if (
        this.options.transparent &&
        this.element.classList.contains("Header--Transparent")
      ) {
        this.element.classList.remove("Header--Transparent");
      }
    } else {
      this.element.classList.remove("Header--Scrolled");
      if (this.options.transparent) {
        this.element.classList.add("Header--Transparent");
      }
    }

    if (!this.element.querySelector(".header--LogoWrapper")) return;
    this.element.querySelector(".header--LogoWrapper").removeAttribute("style");
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);



    const bestsellers = this.element.querySelector(".mobile-menu__bestsellers.swiper");
    const isDesktop = new Responsive().matchesBreakpoint("lap_and_up");
    if (bestsellers && !isDesktop) {
      new RevolutionSwiper(bestsellers);
      new AddToCart(bestsellers);
    }

    this.alphabeticalOrder();
  }

  alphabeticalOrder() {
    const selectorsWrapper = this.element.querySelector(".RevolutionSelectbox--InnerContent");

    if (!selectorsWrapper) {
        console.error("selectorsWrapper not found");
        return;
    }

    const items = Array.from(selectorsWrapper.children);

    items.sort((a, b) => {
        const textA = a.textContent.trim().toLowerCase();
        const textB = b.textContent.trim().toLowerCase();
        return textA.localeCompare(textB);
    });

    selectorsWrapper.innerHtml = "";

    items.forEach(item => selectorsWrapper.appendChild(item));
}

}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
  
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (this.element.getAttribute("loaded")) return; 
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );

      this.element.appendChild(node.firstElementChild).focus();
      
    

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
    
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }

    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
        ? "video/vimeo"
        : "video/mp4";
    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer"
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };


    const videoplayerID = this.element.querySelector("video");
    if (!videoplayerID) {
  console.error("Video element not found.");
  return;
}
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options["controls"]) {
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }

    this.element.setAttribute("loaded", true);
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.notifyMeBtns = this.querySelectorAll(".Button--NotifyMe");
    this.notifyMeOverlay = this.element.querySelector(".notifyMeOverlay");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options["slides_number"] > 1) {
      if (this.options["show_thumbnails"]) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }

      this.swiper = this.carouselElement.swiper;
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    //new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    const ratingsLink = this.element.querySelector(".ProductInfo--RatingsLink");
    const targetElem = document.querySelector("#judgeme_product_reviews");
    if (ratingsLink && targetElem) {
      if (ratingsLink.href || targetElem) ratingsLink.style.cursor = "pointer";
      else ratingsLink.style.cursor = "default";
      this.domDelegate.on("click", '[data-action="scroll"]', (e) => {
        e.preventDefault();
        targetElem.scrollIntoView({ behavior: "smooth" });
      });
    }

    const packageSlider = this.element.querySelector(".PackageSwiper");
    if (packageSlider) {
      new RevolutionSwiper(packageSlider);
      const packageSliderWrapper =
        packageSlider.querySelector(".swiper-wrapper");

      this.domDelegate.on(
        "pointerdown",
        '[data-action="cursor"]',
        () => {
          this.mousedown = true;
          packageSliderWrapper.style.cursor = "grabbing";
          document.body.style.cursor = "grabbing";
        },
        false
      );

      this.bodyDelegate.on("pointerup", () => {
        if (!this.mousedown) return;
        this.mousedown = false;
        packageSliderWrapper.style.cursor = "grab";
        document.body.style.cursor = "";
      });
    }

    if (this.options["sticky_atc"]) {
      this.elementToHide = this.element.querySelector(".ProductAction--Sticky");
      this.elementToHide.classList.remove("stickyPopUp");
      this.footer = document.querySelector("#shopify-section-main-footer");
      this.atc = this.element.querySelector(".ScrollToATC");

      this.showStickyAtc();
      window.addEventListener("scroll", this.showStickyAtc.bind(this));
    }
    
    setTimeout(() => { this.changeVariable(); }, 300);

    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    window.addEventListener("resize", this.changeVariable.bind(this));

    this.domDelegate.on(
      "click",
      ".ProductAction--ChangeButton",
      this.scrollToTop.bind(this)
    );

    if (this.options["show_scrollbar"] && this.options["slides_number"] > 1) {
      window.addEventListener("DOMContentLoaded", () => {
        this.updateScrollbar();
        this.swiper.on("slideChange", this.updateScrollbar.bind(this));
      })
    }
  }

  changeVariable() {

    this.element.style.setProperty('--thumb_max_height', `${this.element.querySelector('#productSwiperElement').offsetHeight}px`);
  }

  showStickyAtc() {

    if (
      window.scrollY + window.innerHeight <
        this.footer.getBoundingClientRect().top + window.scrollY &&
      window.scrollY > this.atc.getBoundingClientRect().bottom + window.scrollY
    ) {
      this.elementToHide.classList.add("stickyPopUp");
    } else {
      this.elementToHide.classList.remove("stickyPopUp");
    }
  }

  scrollToTop() {
    const elementToScroll = this.element.querySelector(".ScrollToATC");

    if (elementToScroll) {
      const elementTop = elementToScroll.getBoundingClientRect().top;
      const positionToScroll =
        elementTop +
        window.scrollY +
        elementToScroll.clientHeight -
        window.innerHeight +
        24;

      window.scrollTo({
        top: positionToScroll,
        behavior: "smooth",
      });
    }
  }

  updateImage(event) {

    let imageID = this.options["variant_image_id"];
    if (event) {
       imageID = event.detail.new_image;
    } 
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest('.swiper-slide');
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }

    setTimeout(() => {
      if (this.calledBecauseOfThis && this.options["autoplay_slider"])
        this.swiper.autoplay.start();
      this.calledBecauseOfThis = false;
    }, 300);
  }

  changeImageQuality() {
    const imageToRevealAll = this.element.querySelectorAll(
      ".ProductSlider--ImageFirst"
    );

    if (imageToRevealAll !== null) {
      imageToRevealAll.forEach((item) => {
        const replaceUrl = item.getAttribute("data-original-src");
        item.setAttribute("src", replaceUrl);
      });
    }
  }

  updateScrollbar() {
    const innerBar = this.element.querySelector(".swiper-scrollbar-drag");
    if (!innerBar) return;

    const slideNumber = this.swiper.slides.length > 6 ? 6 : this.swiper.slides.length;
    let activeSlide = this.element.querySelector(".swiper-slide-thumb-active")?.dataset.index || this.swiper.active.index;
    if (activeSlide > 5) activeSlide = 5;

    innerBar.style.top = Math.round(100 / slideNumber) * activeSlide + "%";
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
    this.onQuantityChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`input:checked`).value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".VariantSelect")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`input`)];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.closest(".Selectbox").removeAttribute("variant-notify-me");
        input.removeAttribute("disabled-variant");
      } else {
        input.setAttribute("disabled-variant", "true");
        input.closest(".Selectbox").setAttribute("variant-notify-me", "");
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;

      return !variant.options
        .map((option, index) => {
          return this.options[index] == option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (this.currentVariant) {
      const newMedia = this.currentVariant.featured_media.id;
      if (!newMedia) return;
      this.element.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: { new_image: newMedia },
        })
      );
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) {
      return;
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const variantsWrapper = ".ProductInfo--Wrapper .VariantSelectors";

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const quantityButton = document.querySelector(".QuantityHandler");
        if (quantityButton) {
          const source = html.querySelector(".QuantityHandler");
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }

        this.toggleAddButton();
      });
  }

  toggleAddButton(e) {    
    let quantity = "";
    const addButton = document.querySelectorAll(".MainProduct--ATC"),
      addButtonInner = document.querySelectorAll(
        ".MainProduct--ATC .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    this.notifyMeButtons = document.querySelectorAll("product-component .Button--NotifyMe");
    let buySvg = "";
    
    if (window.variantInfo.show_icon) {
       buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } 
    if (this.currentVariant && this.currentVariant.available == false) {
      if (this.notifyMeButtons) {
        this.notifyMeButtons.forEach((btn) => {
          btn.style.display = "flex";
          btn.removeAttribute("disabled");
        });

        addButton.forEach((btn) => (btn.style.display = "none"));
      } else {
        document
          .querySelectorAll(".Button--NotifyMe")
          .forEach((btn) => (btn.style.display = "none"));
        addButton.forEach((btn) => (btn.style.display = "flex"));
      }

      addButton.forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("ProductCard--Sold__Out");
      });
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
    } else {
      if (this.notifyMeButtons)
        this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
      addButton.forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.classList.remove("ProductCard--Sold__Out");
        btn.style.display = "flex";
      });
      addButtonInner.forEach((btn) => {
       
        if (window.variantInfo.show_price) {
          var priceElement =
            "<span class='u-pb1 mainProductPrice'>&nbsp;" +
            Shopify.formatMoney(
              this.currentVariant.price * quantity,
              window.theme.moneyFormat
            );
          +"</span>";
          btn.innerHTML = window.variantStrings.addToCart + priceElement + buySvg;
        } else {
          btn.innerHTML = window.variantStrings.addToCart + buySvg;
        }
      });
   
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".search__wrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(
      ".search__input--clear"
    );

    this.transitionEndHandlerListener = this.transitionEndHandler.bind(this);
    this.element.addEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;
    this.carouselElement = this.element.querySelector(".search__initial--view");
    if (this.carouselElement) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.element.querySelector(".search__header").offsetHeight}px`
    );

    
    new AddToCart(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );

    this.element.style.display = "block";

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#quick__search");
    if (search) {
      if (new Responsive().matchesBreakpoint("phone")) {
        setTimeout(() => {
          this.element.setAttribute("aria-hidden", "false");
        }, 10);
      } else {
        this.element.setAttribute("aria-hidden", "false");
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.element.querySelector(".search__header").offsetHeight}px`
    );

    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    if (document.querySelector(".Header--Transparent")) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();
    this.eventType = event.type;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);

    const transitionElement = this.element.querySelector(
      ".search__inner--wrapper"
    );

    this.element.addEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.resetSearch();
    this.isOpen = false;
  }

  transitionEndHandler() {
    const selectBoxOpen = document.body.querySelector(
      '#header .RevolutionSelectbox--Button[aria-expanded="true"]'
    );
    if (
      this.headerTransparent &&
      this.eventType != "menu:open" &&
      !selectBoxOpen
    ) {
      document.body.querySelector("#header").toggleColor();
    }
    this.eventType = null;
    this.element.style.display = "none";
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search__wrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".search__input");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(
        ".predictiveSearch--queries"
      );
      const currentRecentQueris = this.element.querySelector(
        "#predictive__search--recent-searches"
      );

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      new AddToCart(this.element);

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
      ".predictiveSearch--queries"
    );
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.searchInputElement.focus();

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");

    let elementToAdd = this.element.querySelector(".search__recent--results");

    if (items.length > 0) {
      const recentItems = items.slice(-3); // Get the last three items
      recentItems.forEach((id) => {
        appendString +=
          "<li role='option' tabIndex='0' class='hoverLinks rte u-p1' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      if (this.querySelector("#predictive__search--popular-searches")) {
        this.querySelector(
          "#predictive__search--recent-searches"
        ).style.display = "none";
        this.querySelector(
          "#predictive__search--popular-searches"
        ).style.display = "block";
      }
    }
  }
}
customElements.define("search-bar", SearchBar);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    this.filterSearchBars = this.element.querySelector(
      ".templateSearch .FilterBar"
    );
    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");

    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );

    this.delegateElement.on("filters:rerendered", () =>
      setTimeout(() => this.updateResultNumber(), 100)
    );

    document.addEventListener(
      "DOMContentLoaded",
      this.updateResultNumber.bind(this)
    );
  }

  updateResultNumber() {
    // Find number of products and articles and display them
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    const itemNumber = this.element.querySelector(".itemNumber");
    if (productElements && productNumber && productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    }
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber === 0) {
        this.openArticleBtn.style.display = "none";
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }
    if (productNumber === 0 && articleNumber !== 0) {
      this.showArticles();
    }
  }

  showProducts() {
    /* //hide filters and search
    this.element.querySelector('.templateSearch .FilterBar').style.display = "flex"; */
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });
    //show filter and searh bar
    /*  if (productNumber === 0) {
      this.element.querySelector('.templateSearch .FilterBar').style.display = "none";
    } else {
      this.element.querySelector('.templateSearch .FilterBar').style.display = "flex";
    } */

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");
  }

  showArticles() {
    /*  //hide filters and search
    this.element.querySelector('.templateSearch .FilterBar').style.display = "none"; */

    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");
  }
}

customElements.define("search-component", Search);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element
        .querySelector(".section-contact__button")
        .removeAttribute("disabled");
    } else {
      this.element
        .querySelector(".section-contact__button")
        .setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");

      document.body.classList.add("scrollLock");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    event.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-reg"]',
      this.accountInputSubmitReg.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );
  }

  accountInputSubmit(event) {
    if (event.key === "Enter") this.submitLogin(event);
  }
  accountInputSubmitReg(event) {
    if (event.key === "Enter") this.submitRegistration(event);
  }
  accountInputSubmitForgot(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.accountRecover(event);
    }
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#RecoverEmail-email-error").innerHTML +
            "</span>";
        } else if (responseText.indexOf("recoverSuccess") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML =
            '<span class="AlertErrorInner pt-m u-p4">' +
            tempDiv.querySelector("#recoverSuccess").innerHTML +
            "</span>";
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        }
        event.target
          .closest("form")
          .querySelector(".itemLoader")
          ?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Create the request body with the registration data
    const requestBody = {
      customer: {
        first_name: this.element.querySelector(
          "#register #RegisterForm-FirstName"
        ).value,
        last_name: this.element.querySelector(
          "#register #RegisterForm-LastName"
        ).value,
        email: this.element.querySelector("#register #RegisterForm-email")
          .value,
        password: this.element.querySelector("#register #RegisterForm-password")
          .value,
      },
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("registerErrors") !== -1) {
          console.log("Error occurred during registration");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

          const emailError = tempDiv.querySelector("#RegisterForm-email-error");
          const passwordError = tempDiv.querySelector(
            "#RegisterForm-password-error"
          );

          if (emailError)
            _this.element.querySelector(
              "#RegisterForm-email-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${
              tempDiv.querySelector("#RegisterForm-email-error").innerHTML
            }</div>`;
          if (passwordError)
            _this.element.querySelector(
              "#RegisterForm-password-error"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pt-m">${
              tempDiv.querySelector("#RegisterForm-password-error").innerHTML
            }</div>`;
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {
          location.href = window.routes.account_url;
        }
        event.target
          .closest("form")
          .querySelector(".itemLoader")
          ?.classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector("#customer_login #CustomerEmail")
          .value,
        password: this.element.querySelector(
          "#customer_login #CustomerPassword"
        ).value,
      },
    };

    event.target
      .closest("form")
      .querySelector(".itemLoader")
      ?.classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("loginError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#login .accountDrawer--ErrorSpace"
          ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${
            tempDiv.querySelector(".AlertError").innerHTML
          }</div>`;

          event.target
            .closest("form")
            .querySelector(".itemLoader")
            ?.classList.remove("is-visible");
        } else if (
          responseText.indexOf("shopify-challenge__container") !== -1
        ) {
          location.href = "/challenge";
        } else {
          location.href = window.routes.account_url;
        }
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
      '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });

    const dataId = event.target.dataset.id;
    this.element
      .querySelectorAll(`.accountDrawer--Tab[data-id="${dataId}"]`)
      .forEach((el) => el.setAttribute("aria-expanded", "true"));

    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.delegateElement = new Delegate(this.element);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.announcementBar = document.querySelector(".announcementBar");

    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    if (this.breakpoint === "desktop" || this.breakpoint === "lap") {
      this.options.enableAnimation = false;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation) {
      this.announcementBar1 = this.element.querySelector(
        "#announcementBar--SwiperWrapperOne"
      );
      this.announcementBar2 = this.element.querySelector(
        "#announcementBar--SwiperWrapperTwo"
      );
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;
    }
    this.bindEvents();
    this.updateVisibleHeight();
  }

  bindEvents() {
    if (this.options.totalBlocks > 0 && this.options.enableAnimation) {
      this.handleSmallAnimation();
    }

    this.delegateElement.on(
      "click",
      ".AnnouncementBar--Close",
      this.updateVisibleHeight.bind(this)
    );
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height

    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  toggleFade() {
    this.announcementBar2.style.display = "flex";

    if (this.fadeToggle) {
      this.announcementBar1.classList.remove("fade-in");
      this.announcementBar2.classList.add("fade-in");
    } else {
      this.announcementBar1.classList.add("fade-in");
      this.announcementBar2.classList.remove("fade-in");
    }

    this.fadeToggle = !this.fadeToggle;
  }

  fadeBig() {
    // Initially fade in the first bar
    this.announcementBar1.classList.add("fade-in");

    this.slides.forEach((slide) => (slide.style.visibility = "visible"));

    if (this.animateBig)
      this.barsTimeout = setInterval(
        () => this.toggleFade(),
        this.options.interval
      );
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove("fade-in");
      }

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  stopFadeBig() {
    this.announcementBar1.style.display = "none";
    this.announcementBar2.style.display = "none";

    this.announcementBar1.classList.remove("fade-in");
    this.announcementBar2.classList.remove("fade-in");

    setTimeout(() => {
      this.announcementBar1.style.display = "flex";
      this.announcementBar2.style.display = "flex";
    }, 100);

    clearTimeout(this.barsTimeout);
  }

  stopFadeSmall() {
    this.slides.forEach((slide) => {
      if (slide.classList.contains("fade-in")) {
        slide.classList.remove("fade-in");
      }
    });
    clearTimeout(this.slidesTimeout);
  }

  handleBigAnimation() {
    if (!this.firstAnimation) {
      this.stopFadeSmall();

      this.announcementBar1.style.display = "none";
      if (this.animateBig) this.announcementBar2.style.display = "none";

      setTimeout(() => {
        this.announcementBar1.style.display = "flex";
      }, 75);

      setTimeout(() => {
        this.fadeBig();
      }, 150);
    } else {
      if (this.animateBig) this.announcementBar2.style.display = "none";
      this.fadeBig();
    }
    if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
  }

  handleSmallAnimation() {
    if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = "none";
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "flex";
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
  }

  handleNoAnimation() {
    this.stopFadeBig();
    this.stopFadeSmall();
  }
}
customElements.define("slider-announcement-bar", SliderAnnouncementBar);
class CloseAnnBar extends HTMLElement {
  constructor() {
    super();

    const annBar = document.querySelectorAll(".announcementBar");
    const closeButton = document.querySelectorAll(".AnnouncementBar--Close");

    closeButton.forEach((closeButton) => {
      closeButton.addEventListener("click", (e) => {
        annBar.forEach((annBar) => {
          annBar.classList.add("hidden");
        });

        sessionStorage.setItem("annBarHidden", true);
      });
    });
    if (sessionStorage.getItem("annBarHidden", true)) {
      annBar.forEach((annBar) => {
        annBar.classList.add("hidden");
      });
    }
  }
}
customElements.define("button-close-section", CloseAnnBar);

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.animHolder = this.element.querySelector(".awards__content-animation");
    this.viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    let padding = parseInt(this.element.dataset.paddingMobile) * 2;
    if (new Responsive().matchesBreakpoint("lap_and_up")) {
      padding = parseInt(this.element.dataset.paddingDesktop) * 2;
    }
    this.lerp = { current: 0, target: 0 };
    this.lerpMain = (current, target, factor) =>
      current * (1 - factor) + target * factor;
    this.isAnimating = true; // Flag to control animation
    setTimeout(() => {
      this.init(padding);
    }, 500);

    // Event listeners to stop/start animation
    this.element.addEventListener("mouseover", this.stopAnimation.bind(this));
    this.element.addEventListener("mouseout", this.startAnimation.bind(this));
    this.element.addEventListener("touchstart", this.stopAnimation.bind(this));
    this.element.addEventListener("touchend", this.startAnimation.bind(this));
  }

  init(padding) {
    const widthOfScreen = this.viewportWidth - padding;

    const doesOverflowHorizontal = this.animHolder.offsetWidth > widthOfScreen;

    if (!doesOverflowHorizontal) return;

    this.lerp = { current: 0, target: 0 };
    this.interpolationFactor = 0.1;
    this.speed = this.element.dataset.speed / 100;
    this.direction = -1; // -1 (to-left), 1 (to-right)

    const toClone = this.element.querySelector(".awards__content-animation");
    toClone.classList.add("awards__last--padding");
    this.cloneElements();

    this.resizeObserver = new ResizeObserver((changes) => {
      for (const change of changes) {
        this.element.style.cssText = `position: relative; display: inline-flex; white-space: nowrap; width: ${
          change.contentRect.width + 16
        }px`;
        this.element.children[1].style.cssText = `position: absolute; left: calc(${
          change.contentRect.width * -this.direction
        }px + 16px); width: fit-content; justify-content: flex-start`;

        this.render();
      }
    });

    this.resizeObserver.observe(this.animHolder);
  }

  cloneElements() {
    const fragment = document.createDocumentFragment();
    /*     this.animHolder.classList.add("pr-xxl"); */
    this.animHolder.style.justifyContent = "flex-start";
    this.animHolder.style.width = "fit-content";
    for (var i = 0; i < this.element.childNodes.length; i++) {
      const clonedChild = this.element.childNodes[i].cloneNode(true);
      fragment.appendChild(clonedChild);
    }

    this.element.appendChild(fragment);
  }

  animate() {
    if (this.isAnimating) {
      this.lerp.target += this.speed;
      this.lerp.current = this.lerpMain(
        this.lerp.current,
        this.lerp.target,
        this.interpolationFactor
      );
      if (this.lerp.target > 100) {
        this.lerp.current -= this.lerp.target;
        this.lerp.target = 0;
      }

      const x = this.lerp.current * this.direction;
      this.element.style.transform = `translateX(${x}%)`;
    }
  }

  render() {
    this.animate();
    window.requestAnimationFrame(() => this.render());
  }

  stopAnimation() {
    this.isAnimating = false;
  }

  startAnimation() {
    this.isAnimating = true;
  }
}

customElements.define("animation-text", AnimationText);

class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("blog-showcase", BlogShowcaseSlider);

class CommentSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.whireCommentBtn = this.element.querySelector(".Comments--WhireButton");
    this.revealWrapper = this.element.querySelector(".Comments--RevealWrapper");
    this.currentPageKey = this.extractStringFromURL(window.location.href);
    this.openedCom = this.querySelector(".show-comments");
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.articleWrapper = this.element.querySelector(
      ".Comments--ArticleWrapper"
    );

    if (this.openedCom) {
      this.woosh();
    }

    if (this.articleWrapper)
      this.allChildren = Array.from(this.articleWrapper.children);
    this.paginationWrapper = this.element.querySelector(".pagination__wrapper");
    /*  this.loadMoreBtn = this.element.querySelector('.Comments--loadMoreButton'); */

    const beenHere = sessionStorage.getItem("postRequest");
    if (beenHere == this.currentPageKey) {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    } else {
      this.bindWhireBtnListener();
    }

    this.mobile = new Responsive().matchesBreakpoint;


    this.handleAfterState();
    this.bindListeners();
  }

  bindListeners() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.textArea = this.element.querySelector("#CommentForm-body");
    const formListener = this.element.querySelector("#comment_form");

    this.textAreaFunc = this.expandDynamically.bind(this);
    /*     if(this.loadMoreBtn) this.loadMoreBtn.addEventListener('click', this.updateComments.bind(this)); */
    formListener.addEventListener("submit", this.verifyForm.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    if (this.buttonState == true) {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .removeAttribute("disabled");
    } else {
      this.element
        .querySelector(".Comments--SendButton .Button")
        .setAttribute("disabled", true);
    }
  }

  handleAfterState() {
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element
        .querySelector(".Comments--WhireButton")
        .setAttribute("aria-hidden", "true");
    }
  }

  loadMore(event, target) {
    const _this = this;
    let dataHref = target.getAttribute("data-href");

    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll(".ArticleComments--Comment");

        let curDocument = _this.element.querySelector(".ArticleComments");
        curDocument.append(...newComments);
        let dataHref = html.querySelector("[data-href]");

        if (dataHref) {
          dataHref = dataHref.dataset.href;
          _this.element.querySelector("[data-href]").dataset.href = dataHref;
        } else {
          _this.element.querySelector(".comments--buttonFooter")?.remove();
        }
      });
    });
  }

  reduceArticles() {
    if (this.paginationWrapper) this.paginationWrapper.style.display = "none";

    if (this.articleWrapper) {
      while (this.articleWrapper.children.length > 3) {
        this.articleWrapper.removeChild(this.articleWrapper.lastChild);
      }
    }
  }

  updateComments() {
    this.loadMoreBtn.style.display = "none";

    for (const child of this.allChildren) {
      this.articleWrapper.appendChild(child);
    }

    this.paginationWrapper.style.display = "block";
    sessionStorage.setItem("openedComments", true);
  }

  verifyForm(e) {
    const requiredCheckboxes = document.querySelectorAll(
      "input.Comments--Required"
    );
    const uncheckedCheckboxes = [];

    requiredCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        e.preventDefault();
        uncheckedCheckboxes.push(checkbox);
      }
    });

    if (uncheckedCheckboxes.length > 0) {
      uncheckedCheckboxes.forEach((checkbox) => {
        const errorMessageElement = checkbox.parentElement
          .querySelector(`label[for=${checkbox.id}]`)
          ?.querySelector(".Comments--ErrorMessage");
        if (errorMessageElement)
          errorMessageElement.classList.add("showCommentErrorMsg");
      });
    } else {
      if (this.currentPageKey.includes("#comment_form")) {
        sessionStorage.setItem("postRequest", this.currentPageKey);
      } else {
        sessionStorage.setItem(
          "postRequest",
          this.currentPageKey + "#comment_form"
        );
      }
    }
  }

  onResize() {
    if (window.innerWidth < 1024) {
      this.textArea.addEventListener("input", this.textAreaFunc);
      this.expandDynamically();
      this.mobile = true;
    } else {
      this.textArea.removeEventListener("input", this.textAreaFunc);
      this.textArea.style.height = "128px";
      this.mobile = false;
    }
  }

  expandDynamically() {
    this.textArea.style.height = "42px";

    const scrollHeight = Math.max(
      this.textArea.scrollHeight,
      this.textArea.clientHeight
    );
    if (scrollHeight < 42) return;
    this.textArea.style.height = scrollHeight + "px";
  }

  extractStringFromURL(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  calculateFitContentHeight(elem) {
    const clone = elem.cloneNode(true);
    clone.style.visibility = "hidden";
    clone.style.height = "fit-content";
    this.element.appendChild(clone);
    const computedHeight = window.getComputedStyle(clone).height;
    this.element.removeChild(clone);

    return computedHeight;
  }

  bindWhireBtnListener() {
    this.wooshListener = this.woosh.bind(this);
    this.whireCommentBtn.addEventListener("click", this.wooshListener);
  }

  woosh(e) {
    this.element
      .querySelector(".Comments--SendButton .Button")
      .setAttribute("disabled", true);



    this.whireCommentBtn.style.opacity = "0";
    this.whireCommentBtn.style.pointerEvents = "none";
    if (this.mobile) this.whireCommentBtn.style.marginTop = "-68px";

    const height = this.calculateFitContentHeight(this.revealWrapper);
    this.revealWrapper.style.height = height;
    setTimeout(() => {
      this.revealWrapper.style.height = "fit-content";
      this.whireCommentBtn.style.display = "none";
    }, 1000);

    this.whireCommentBtn.removeEventListener("click", this.wooshListener);
    if (e) {
      e.preventDefault();
    }
  }
}
customElements.define("comment-section", CommentSection);

class CustomReviews extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.initOpenCarousel();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
  }

  toggleTab() {
    const id = event.target.dataset.id;
    const openTab = this.element.querySelector(
      '.custom-reviews__tab[aria-expanded="true"]'
    );
    const openContent = this.element.querySelector(
      '.custom-reviews__content[aria-hidden="false"]'
    );

    openTab.setAttribute("aria-expanded", "false");
    event.target.setAttribute("aria-expanded", "true");
    openContent.setAttribute("aria-hidden", "true");

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      this.carousel.swiperElement.destroy();
      content.setAttribute("aria-hidden", "false");
      this.initCarousel(content);
    }
  }

  initOpenCarousel() {
    const carousel = this.element.querySelector('.swiper[aria-hidden="false"]');
    requestAnimationFrame(() => {
    this.initCarousel(carousel);
  });
  }

  initCarousel(carousel) {

    this.carousel = new RevolutionSwiper(carousel);

  }
}

customElements.define("custom-reviews", CustomReviews);

class faqSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.clicked = false;
    // Initialize the observer for scroll events
    this.initObserver();

    // Initialize the Swiper carousel
    this.carousel = new RevolutionSwiper(this.element.querySelector("[data-swiper-settings]"));
    window.carousel = this.carousel;

    // Remove padding from the second child title
    const parentDiv = document.querySelector(".FAQ");
    if (parentDiv) {
      const secondChild = parentDiv.children[1];
      if (secondChild) secondChild.style.paddingTop = "0";
    }

    // Bind events to the elements
    this.bindEvents();
  }

  // Method to bind events
  bindEvents() {
    this.handleScrollListener = this.handleScroll.bind(this);
    this.delegateElement.on("click", '[data-action="handle-click"]', this.handleClick.bind(this));
    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));
    this.delegateElement.on("click", '[data-action="clear-search-d"]', this.clearSearchDesktop.bind(this));
    this.delegateElement.on("keyup", '[data-action="search-string"]', this.handleSearch.bind(this));
  }

  // Method to handle inserting text in input field
  insertInInput(event, target) {
    const inputEl = this.element.querySelector(".faq--search.mobile");
    if (inputEl) {
      inputEl.value = event.target.textContent;
    }
  }

  // Method to handle search functionality
  handleSearch(event) {
    const allTitles = this.element.querySelectorAll('.FAQSubheader--title');
    allTitles.forEach((title) => { title.style.display = 'block'; });

    const firstTitle = this.element.querySelector('.FAQSubheader--firstTitle');
    if (firstTitle) {
      firstTitle.classList.remove('FAQSubheader--firstTitle');
    }

    // Mobile clear button handling
    const clearBtn = this.element.querySelector(".clearSearch.supportFaq--mobileClearBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile").value;
    clearBtn.style.display = inputValue ? "flex" : "none";

    const noneTerms = this.querySelectorAll(".noTerms");
    noneTerms.forEach((el) => (el.textContent = `"${inputValue}"`));

    this.quickSearch(inputValue);
  }

  // Method to perform quick search
  quickSearch(inputSearch) {
    const allSections = this.element.querySelectorAll('.Faq-Section');
    allSections.forEach((title) => { title.style.display = 'block'; });
    
    inputSearch = inputSearch.toLowerCase();
    const divContainers = this.querySelectorAll(".FAQ--Terms");

    divContainers.forEach((container) => {
      const containerText = container.textContent.toLowerCase();
      const matches = containerText.includes(inputSearch);

   
      container.classList.toggle("supportFaq--showed", matches);
      const faqSection = container.closest('.Faq-Section');
      const hasShownSubheader = faqSection && faqSection.querySelector('.FAQSubheader--title.supportFaq--showed');
    
      if (matches || hasShownSubheader) {
          container.style.display = "block";
      } else {
        
          container.style.display = "none";
      }
  });

   this.handleTitles();
    this.handleNoResults(divContainers);
  }

  // Method to handle title visibility
  handleTitles() {
    const allTitles = this.element.querySelectorAll('.FAQSubheader--title');
    let firstTitle = true;

    allTitles.forEach((title) => { 

   
      const parent = title.closest('.Faq-Section');
      const showed = parent.querySelector('.supportFaq--showed');

      title.style.display = showed ? 'block' : 'none';

      if(!showed) {
        parent.style.display = 'none';
      }

      if (showed && firstTitle) {
        parent.classList.add('FAQSubheader--firstTitle');
        firstTitle = false;
      }
    });
  }

  // Method to handle "no results" text visibility
  handleNoResults(containers) {
    const noResults = ![...containers].some(container => container.classList.contains("supportFaq--showed"));
    const noResEl = this.querySelectorAll(".faq--noResultsText");

    noResEl.forEach((item) => {
      item.style.display = noResults ? "flex" : "none";
      item.classList.toggle("noResult--showed", noResults);
    });
  }

  // Method to clear mobile search input
  clearSearch() {
    const clearBtn = this.element.querySelector(".clearSearch.supportFaq--mobileClearBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile");
    const noResEl = this.element.querySelector(".faq--noResultsText");

    if (inputValue) inputValue.value = "";
    if (clearBtn) clearBtn.style.display = "none";
    if (noResEl) noResEl.style.display = "none";

    const allSections = this.element.querySelectorAll('.Faq-Section');
    allSections.forEach((title) => { title.style.display = 'block'; });

    const allTitles = this.element.querySelectorAll('.FAQSubheader--title');
    allTitles.forEach((title) => { title.style.display = 'block'; });

    const firstTitle = this.element.querySelector('.FAQSubheader--firstTitle');
    if (firstTitle) firstTitle.classList.remove('FAQSubheader--firstTitle');

    this.quickSearch("");
  }

  // Method to clear desktop search input
  clearSearchDesktop() {
    const clearBtn = this.element.querySelector(".clearSearch.supportFaq--desktopClearBtn");
    const inputValue = this.element.querySelector(".faq--search.desktop");

    if (inputValue) inputValue.value = "";
    if (clearBtn) clearBtn.style.display = "none";

    const allTitles = this.element.querySelectorAll('.FAQSubheader--title');
    allTitles.forEach((title) => { title.style.display = 'block'; });

    const firstTitle = this.element.querySelector('.FAQSubheader--firstTitle');
    if (firstTitle) firstTitle.classList.remove('FAQSubheader--firstTitle');

    this.quickSearch("");
  }

  // Method to handle click events
  handleClick(event) {

    this.element.dataset.clicked = "true";
    const allLinks = this.element.querySelectorAll(".FaqLinkList__Item");
    allLinks.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
    event.target.classList.add("CurrentLinkPage");
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 200);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".CurrentLinkPage");
    linkedItems.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
  }

  // Method to initialize the scroll observer
  initObserver() {
    window.addEventListener("scroll", this.handleScrollListener);
  }



  // Method to handle scroll events
  handleScroll() {

    if(this.element.dataset.clicked == "true") return;
    const faqSubheaders = this.element.querySelectorAll(".FAQSubheader--main");
    const faqMenuTabsWrapper = this.element.querySelectorAll(".faq--menuTabsWrapper");
    const threshold = 100;

    if (new Responsive().matchesBreakpoint("pocket")) {
      faqMenuTabsWrapper.forEach((item) => {
        const distanceFromTop = item.getBoundingClientRect().top;
        item.style.boxShadow = (distanceFromTop <= 52 && distanceFromTop > 0) ? "0px 4px 12px 0px rgba(20, 20, 20, 0.10)" : "none";
      });
    } 

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(0, faqSubheader.getBoundingClientRect().top);
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".Faq-Section").id;
        const anchorElements = this.element.querySelectorAll(`a[href="#${faqSection}"]`);

        anchorElements.forEach((item) => {
          item.classList.add("CurrentLinkPage");
          if (new Responsive().matchesBreakpoint("pocket") && !item.classList.contains("swiper-slide-active")) {
            this.carousel.swiperElement.slideTo(parseInt(item.dataset.index));
          }
        });
      }
    });
  }
}

customElements.define("faq-section", faqSection);


class FAQContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-faq", FAQContactSection);

class LegalSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.initObserver();
    this.termsMenuTabsWrapper = document.querySelector(".terms--block");
    if (!new Responsive().matchesBreakpoint("lap_and_up")) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
  initObserver() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const distanceFromTop =
      this.termsMenuTabsWrapper.getBoundingClientRect().top;
    const threshold = 52;
    if (distanceFromTop <= threshold && distanceFromTop > 0) {
      this.termsMenuTabsWrapper.style.boxShadow =
        "0px 4px 12px 0px rgba(20, 20, 20, 0.10)";
    } else {
      this.termsMenuTabsWrapper.style.boxShadow = "none";
    }
  }
}

customElements.define("legal-swiper", LegalSwiper);

sessionStorage.setItem("firstLoadFav", true);
class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".spinningLoader");
    this.cartCount = document.querySelector(".FavoritesCount");
    this.favEmpty = document.querySelectorAll(".TopBar--FavEmpty");
    this.favFull = document.querySelectorAll(".TopBar--FavFull");
    this.promiseFirst = true;

    new AddToCart(this.element)

    if (sessionStorage.getItem("firstLoadFav") === "true") {
      sessionStorage.setItem("firstLoadFav", false);
      this.loader.classList.add("is-visible");
      this.rerenderFavorites();
    }

    this.loadRecommendations();
    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents() {
    document.removeEventListener(
      "favorite-product:open",
      this.onFavoritesOpenListener
    );

    document.removeEventListener("click", this._addToFavoritesL);
  }
  bindEvents() {
    if (!document.body.classList.contains("listener")) {
      this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
      this._addToFavoritesL = this.addToFavorites.bind(this);

      this.delegateBody.on(
        "click",
        '[data-action="toggle-favorites"]',
        this._addToFavoritesL
      );
      document.body.classList.add("listener");
      document.addEventListener(
        "favorite-product:open",
        this.onFavoritesOpenListener
      );
      document.addEventListener(
        "favorites:toggle",
        this.toggleFavorites.bind(this)
      );
    }
  }

  onFavoritesOpen() {
    this.sidebarDrawer.isOpen = true;
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // Filter out null values
    items = items.filter((id) => id !== null);
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .filter((id) => id !== null) // Filter out null values
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      if (string) {
        acc.push(string); // Add the string to the result array if it's not empty
      }
      return acc;
    }, []);
  }

  hideLoader(noDelay) {
    let delay;
    noDelay ? (delay = 0) : (delay = 500);
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, delay);
  }

  rerenderFavorites(openfavorites) {
  
    const _this = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
    if (queryStrings.length == 0)
      this.favFull.forEach((icon) => (icon.style.opacity = 0));
    else this.favFull.forEach((icon) => (icon.style.opacity = 1));
  
    if (queryStrings.length == 0 && !openfavorites) {
      fetch("/?section_id=main-favorites_drawer").then(function (content) {
        content.text().then(function (html) {
          _this.replaceContentFav(html);
          _this.loadRecommendations();
        });
      });
    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
  
    Promise.all(promises)
      .then((responses) => Promise.all(responses.map((r) => r.text())))
      .then((contents) => {
        contents.forEach((content, index) => {
          if(this.promiseFirst == true){
            _this.replaceContentFav(content);
            this.promiseFirst = false;
          } else {
            _this.addContent(content);
          }

          const isLast = index === contents.length - 1;
          if(isLast){
            this.promiseFirst = true;
          }
  
        });
        _this.loadRecommendations();
      })
      .catch((error) => {
        console.error("Error loading favorites:", error);
        _this.hideLoader();
      });
  
    return Promise.resolve();
  }

  addContent(html) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const productCards = tempElement.querySelectorAll("product-card");
    const container = this.element.querySelector(".FavoriteGrid");
  
    productCards.forEach((card) => {
      container.appendChild(card);
    });
  
    this.toggleFavorites();
    this.hideLoader();
  }

  replaceContentFav(html) {
    
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var cartNodeParent = this.element.querySelector(
      ".FavoritesDrawer .FavoriteItems--Wrapper"
    );

    cartNodeParent.replaceChild(
      tempElement.querySelector("#main-favorites_items"),
      this.element.querySelector("#main-favorites_items")
    );

    if (
      cartNodeParent
        .querySelector("#main-favorites_items")
        .querySelector(".favEmpty")
    ) {
      cartNodeParent
        .querySelector("#main-favorites_items")
        .classList.add("FavEmptyItems");
    }

    this.toggleFavorites();
    this.hideLoader();
    if (
      document
        .querySelector("favorites-drawer")
        .getAttribute("aria-expanded") == "true"
    ) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = [
      ...document.querySelectorAll(".product-card__favorites-icon"),
      ...document.querySelectorAll(".MainProduct--FavoritesIcon"),
    ];

    if (document.body.querySelector(".emptyFavorite")) {
      if (items.length > 0) {
        document.body.querySelector(".emptyFavorite").style.display = "none";
        document.body.querySelector(".solidFavorite").style.display = "flex";
      } else {
        document.body.querySelector(".emptyFavorite").style.display = "flex";
        document.body.querySelector(".solidFavorite").style.display = "none";
      }
    }
    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
      if (state == "not-active" && items.includes(myID)) {
        item.querySelector(".solidFavorite").style.display = "flex";
        item.querySelector(".emptyFavorite").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".solidFavorite").style.display = "none";
        item.querySelector(".emptyFavorite").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);
    if (items.length == 0) this.loader.classList.add("is-visible");
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();
    this.loader.classList.add("is-visible");
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });
  }

  loadRecommendations() {
    var _this = this;

    if (this.options["productId"] == "") {
      var url = "?section_id=helper-recommendations_favorites";
    } else {
      var url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=helper-recommendations_favorites&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        const container = document.createElement("div");
        if (container) container.innerHTML = content;

        if (container) {
          var z = container.querySelector(".Upsell__Container").innerHTML;
          var x = _this.element.querySelector(".recommSwiper .swiper-wrapper");
          if (x != null) {
            x.innerHTML = z;
          }
        }

        const swiperElem = _this.element.querySelector(".recommSwiper:not(.swiper-initialized)");
        if (swiperElem) {
          new Swiper(swiperElem, {
            // Default parameters
            slidesPerView: 1.2,
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
            autoHeight: false,
            mousewheel: {
              forceToAxis: true,
            },
            navigation: {
              nextEl: ".favorites__swiper-button--nextEl",
              prevEl: ".favorites__swiper-button--prevEl",
            },
            breakpoints: {
              1025: {
                slidesPerView: 2,
                spaceBetween: 0,
              },
            },
          });
        }

        new AddToCart(x);
        _this.toggleFavorites();

        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }

  addToFavorites(event) {
    var _this = this;
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    if (items.length == 0) this.loader.classList.add("is-visible");
    var productId = event.target.parentElement.getAttribute("data-id");
    if (!productId) productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();

      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class DownloadItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="download-all"]',
      this.downloadAll.bind(this)
    );
  }

  downloadAll() {
    event.preventDefault();
    const urls = this.element.querySelectorAll(".text-container__button2");

    urls.forEach((url) => {
      url.click();
    });
  }
}
customElements.define("download-items-component", DownloadItems);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    document.documentElement.style.setProperty(
      "--footer-height",
      document.querySelector(".main-footer__wrapper").offsetHeight + "px"
    );

    window.onload = () =>
      setTimeout(() => {
        document.documentElement.style.setProperty(
          "--footer-height",
          document.querySelector(".main-footer__wrapper").offsetHeight + "px"
        );
      }, 500);

    this.alphabeticalOrder();
  }

  connectedCallback() {
    this.delegateElement.on(
      "click",
      ".footer__submit--arrow",
      this.footerFormValidate.bind(this)
    );
  }

  footerFormValidate(event) {
    const footerForm = this.element.querySelector(".contact-form");
    const emailInput = footerForm.querySelector('input[type="email"]');
    const errorContainer = this.element.querySelector(".footer-error");
    const newsletterInput = this.element.querySelector(".newsletter__inputs");
    const inputField = this.element.querySelector(".input-placeholder");
    const submitArrow = this.element.querySelector(".footer__submit--arrow");

    if (footerForm.checkValidity()) return console.log("izaso");

    event.preventDefault();
    event.stopPropagation();

    if (!emailInput || !errorContainer) return footerForm.reportValidity();

    errorContainer.style.display="flex";
    errorContainer.classList.add("footer-error-visible");
    newsletterInput.classList.add("newsletter__inputs_error");
    inputField.classList.add("input-placeholder__error", "error");
    submitArrow.classList.add("error", "arrow-error");
  }

  alphabeticalOrder() {
    const selectorsWrapper = this.element.querySelector(".RevolutionSelectbox--InnerContent");

    if (!selectorsWrapper) {
      console.error("selectorsWrapper not found");
      return;
    }

    const items = Array.from(selectorsWrapper.children);

    items.sort((a, b) => {
      const textA = a.textContent.trim().toLowerCase();
      const textB = b.textContent.trim().toLowerCase();
      return textA.localeCompare(textB);
    });

    selectorsWrapper.innerHTML = "";

    items.forEach((item) => selectorsWrapper.appendChild(item));
  }
}

customElements.define("footer-component", FooterComponent);


class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.handleColorSwatch();

  }


  connectedCallback() {

    this.delegateElement.on(
      "click",
      '[data-action="selectbox-select"]',
      this.onProductCardChange.bind(this),
    );

    this.delegateElement.on(
      "keydown",
      '[data-action="selectbox-select"]',
      this.checkTheBox.bind(this)
    );

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.handleColorSwatch(entry);

          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: "-100px 0px 200px 0px",
    });

    this.observer.observe(this);

    responsive.addResizeListener(this, this.handleColorSwatch.bind(this));
  }



  checkTheBox(e) {

    if (e.key === "Enter") {
      e.preventDefault();

      const inputElement = e.target.querySelector("input");
      inputElement.checked = true;

   this.onProductCardChange(e, inputElement);
    }
  }

  onProductCardChange(e, targetElement) {
    e.preventDefault();


    var target = e.target;
    if (targetElement) target = targetElement;

    const productId = target.dataset.id;
    if(!productId) return;
    const url = `${window.routes.localeRootUrl}/search?view=product-card&q=id:${productId}`;

    this.replaceProductCard(url, productId);
  }

  async replaceProductCard(url, productId) {
    try {
      const response = await fetch(url);
      const responseText = await response.text();
      const htmlDocument = new DOMParser().parseFromString(responseText, "text/html");
      const newProductCard = htmlDocument.querySelector(`#product-card__${productId}`);
      
      if (!newProductCard) throw "Product card not found in fetched HTML."
      this.element.innerHTML = newProductCard.innerHTML;
      
    } catch (error) {
      console.error("Error fetching product:", error);
    }
    this.handleColorSwatch();

  }

  handleColorSwatch() {    
    this.swatchWrapper = this.element.querySelector(".product-card__color-selector");
    this.swatchMoreLabel = this.element.querySelector(".product-card__more-label");
    this.swatches = this.element.querySelectorAll(".product-card__selectbox");

    if (!this.swatchWrapper || this.swatches.length === 0 || !this.swatchMoreLabel) return;
    
    this.totalSwatches = this.swatches.length;
    this.visibleSwatchCount = this.totalSwatches;
    
    this.swatchWidth = 28;     
    this.moreLabelWidth = 28;  
    
    this.availableWidth = this.swatchWrapper.offsetWidth;
    if (!this.availableWidth) return;

    const remainingWidth = this.availableWidth - this.moreLabelWidth - 68;
    this.maxVisibleSwatches = Math.floor(remainingWidth / this.swatchWidth);
    
    this.maxVisibleSwatches = Math.min(this.totalSwatches, Math.max(1, this.maxVisibleSwatches));
    
    this.swatches.forEach(swatch => {
      swatch.style.display = "flex";
    });
    
    if (this.totalSwatches <= this.maxVisibleSwatches) {
      this.swatchMoreLabel.style.display = 'none';
      return;
    }
    
    let hiddenCount = 0;
    for (let i = this.totalSwatches - 1; i >= this.maxVisibleSwatches; i--) {      
      this.swatches[i].style.display = 'none';
      hiddenCount++;
    }
      
    this.swatchMoreLabel.style.display = 'flex';
    const labelText = this.swatchMoreLabel.querySelector('.product-card__label-text');
    if (labelText) {
      labelText.innerText = '+' + hiddenCount;
    }
    
    this.visibleSwatchCount = this.totalSwatches - hiddenCount;
  }
}
customElements.define("product-card", ProductCard);

sessionStorage.setItem("firstLoadRecomm", true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this);

    new AddToCart(this.element)

    if (sessionStorage.getItem("firstLoadRecomm") === "true") {
      this.loadRecommendations();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="select"]',
      this.selectSwiper.bind(this)
    );
  }

  selectSwiper(e) {
    const targetId = e.target.closest("[data-id]").dataset.id;

    const prevSelected = this.element.querySelectorAll(".selected[data-id]");
    prevSelected.forEach((el) => el.classList.remove("selected"));

    const newSelected = this.element.querySelectorAll(
      `[data-id="${targetId}"]`
    );
    newSelected.forEach((el) => el.classList.add("selected"));
  }

  loadRecommendations() {
    sessionStorage.setItem("firstLoadRecomm", false);
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          const carouselElementNew =
            recommendations.querySelectorAll(".swiper");
          const carouselElementOld = this.querySelectorAll(".swiper");
          const giftSlide = this.querySelector(".gift__card-slide");
         
          carouselElementOld.forEach((swiper, i) => {
            swiper.parentNode.replaceChild(carouselElementNew[i], swiper);

            new RevolutionSwiper(carouselElementNew[i]);
            new RevolutionAnimation(carouselElementNew[i], true);

            if (giftSlide) {
              const wrapper = carouselElementNew[i].querySelector(".swiper-wrapper");

              const newGiftSlide = giftSlide.cloneNode(true);
              newGiftSlide.classList.add("swiper-slide");
              wrapper.appendChild(newGiftSlide);

                new RevolutionAnimation(giftSlide, true);
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.delegateElement = new Delegate(this.element);
   
    const checkboxes = this.element.querySelectorAll(
      ".terms-checkbox-container"
    );
    checkboxes.forEach((el) => (el.querySelector("input").checked = false));
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;
    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });

    const button = this.element.querySelector(".cartCheckout--Button")

    if (this.buttonState == true) {
      button.removeAttribute("disabled");
    } else {
      button.setAttribute("disabled", true);
    }
  }
}
customElements.define("cart-items", CartItems);

class SideCartVariant extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.form = this.element.querySelector(".sidecart_input-value");
    this.form_id = this.form.getAttribute("value");
    let selectBox = this.element.querySelector(".SelectboxCircle");
    if (selectBox) {
      selectBox.classList.add("outline");
    }
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="select-variant"]',
      this.selectVariant.bind(this)
    );
  }

  selectVariant(event, target) {
    event.preventDefault();
    this.changeImage(event, target);
    let current_variant = this.element.querySelector(".sidecart_input-value");
    let current_variant_id = current_variant.getAttribute("value");
    let selected_variant_id = target.getAttribute("value");
    current_variant.setAttribute("value", selected_variant_id);
    current_variant_id = current_variant.getAttribute("value");

    if (current_variant_id == selected_variant_id) {
      let all_selectoboxes = this.element.querySelectorAll(".outline");
      all_selectoboxes.forEach((circle) => circle.classList.remove("outline"));
      target.classList.add("outline");
    } else {
      target.classList.remove("outline");
    }
  }

  changeImage(event, target) {
    let variant_image = target.querySelector(".sidecart_variant");
    if (variant_image) {
      const newMedia = variant_image.getAttribute("src");
      const newMedia_srcset = variant_image.getAttribute("srcset");
      this.element.dispatchEvent(
        new CustomEvent("side-cart-variant:changed", {
          bubbles: true,
          detail: { new_image: newMedia, new_srcset: newMedia_srcset },
        })
      );
    }
  }
}
customElements.define("side-cart-variant", SideCartVariant);

// used for appikon back in stock
class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delBody = new Delegate(document.body);
    this.delElem = new Delegate(this.element);
  }

  connectedCallback() {
    this.delBody.on('click', '[data-action="back-in-stock-open"]', this.openPopup.bind(this));
    this.delElem.on('click', '[data-action="notify-close"]', this.closePopup.bind(this));
    this.delElem.on('click', '[data-action="subscribe"]', this.subToNotifyMe.bind(this));
    this.delElem.on('submit', '[data-action="subscribe"]', this.subToNotifyMe.bind(this));
  }

  openPopup() {
    event.preventDefault();
    event.stopPropagation();    

    const overlay = document.querySelector(".pageOverlay");
    overlay?.classList.add("is-visible");

    this.replaceImage(event.target);

    this.element.setAttribute("aria-hidden", false);
    bodyScrollLock.disableBodyScroll(this.element);

    const form = event.target.closest("form");
    if (!form) return;

    const input = form.querySelector('[name="id"]');
    this.productId = input?.dataset.productid || null;
    this.productHandle = input?.dataset.productHandle || null;
    this.variantId = input?.value || null;

    this.bindClosePopup = this.closePopup.bind(this);
    overlay.addEventListener("click", this.bindClosePopup);
  }

  closePopup() {
    const overlay = document.querySelector(".pageOverlay");
    overlay?.classList.remove("is-visible");

    this.element.setAttribute("aria-hidden", true);
    bodyScrollLock.clearAllBodyScrollLocks();
    overlay.removeEventListener("click", this.bindClosePopup);

    this.hideSuccessState();
  }

  async subToNotifyMe() {
    event.preventDefault();
    event.stopPropagation();

    if (!this.productId || !this.variantId) return this.closePopup();

    const form = event.target.closest("form");
    const emailInput = form.querySelector('input[type="email"]');    

    if (!form.checkValidity()) return form.reportValidity();

    const email = emailInput.value;
    
    if (!window.modalHtml) {
      const modalHtml = initVar.stockWidget.modalHtml;
      const div = document.createElement("div");
      div.innerHTML = modalHtml;

      window.modalHtml = div;
    }

    if (initVar.stockFulFilledEmailCampaign.isActive) {
      const modalData = window.growCampaignPopUps?.["gw-stock-fulfilled-iframe"]?.$data || { optInToMarketing: false };
      const workFlowId = initVar.stockFulFilledEmailCampaign.uniqueId;

      const adHocData = {
        email: email,
        optInToMarketing: modalData.optInToMarketing
      };

      const productData = { productId: this.productId, variantId: this.variantId, productHandle: this.productHandle }


      try {
        const response = await kbiteHelper(workFlowId, adHocData, productData);

        if (response.ok) {
          this.showSuccessState();
        }
      } catch(e) {
        console.log(e)
      }
    }
  }

  showSuccessState() {
    const msg = this.element.querySelector("#appikon-bis-inline-form-message");
    msg.setAttribute("aria-hidden", false);
  }

  hideSuccessState() {
    const msg = this.element.querySelector("#appikon-bis-inline-form-message");
    msg.setAttribute("aria-hidden", true);
  }

  replaceImage(target) {
    const imgWrapper = this.element.querySelector(".notify-me__img");
    const oldImg = imgWrapper.querySelector("img");
    const targetWrapper = target.closest("product-component") || target.closest("product-card");

    const imageToClone = targetWrapper.querySelector(".ProductSlider--ImageFirst, .product-card__image")
    if (!imageToClone) return;
    
    const newImg = imageToClone.cloneNode(true);
    imgWrapper.replaceChild(newImg, oldImg);
  }
}

customElements.define("notify-me", NotifyMe);


async function kbiteHelper(campaignId, adHocData, productData) {
  const { productId, variantId, productHandle } = productData;

  try {
    const product = await getProductWithHandle(productHandle)
    const variant = findVariant(product, variantId);

    if (!product || !variant) return;
    
    const mapping = mapData(campaignId, adHocData, product, variant);

    const url = `${initVar.apiUrl}/api/subscribers/campaignMapping`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(mapping)
    });

    return response;
  } catch(e) {
    console.log(e); 
  }
}

function mapData(campaignId, adHocData, product, variant) {
  let subscriptionEvent = {
        productId: Number(product.id),
        productPrice: Number(variant.price),
        variantId: variant.id,
        variantPrice: Number(variant.price),
        productTitle: product.title,
        variantTitle: variant.title,
        href: window.location.href
      }

      if(initVar.recordSku){
        subscriptionEvent.sku = variant.sku ||'-'
      }

      if(initVar.recordMarket){
        subscriptionEvent.country = Shopify.country || ''
        subscriptionEvent.market = window.grow_market || ''
      }

  return {
    campaignUniqueId: campaignId,
    subscriberUniqueId: initVar.subscriberId,
    email: adHocData && adHocData.email,
    smsTarget: adHocData && adHocData.smsTarget,
    smsDialCode: adHocData && adHocData.smsDialCode,
    optInToMarketing: adHocData && adHocData.optInToMarketing,
    subscriptionEvent: subscriptionEvent,
    locale: initVar.getValueIfExist(()=>Shopify.locale)
  };
}

async function getProductWithHandle(handle) {
  if (!handle) return null;
  let product = null;

  try {
    const response = await fetch(`${window.location.origin}/products/${handle}.json`);
    const json = await response.json(); 
    product = json.product;

  } catch (e) {
    initVar.log("Error in fetching product", e)
  }
  
  return product;
}

function findVariant(product, variantId) {
  if (!product) return null;
  variantId = Number(variantId);

  return product.variants.find(variant => variant.id === variantId);
}

class Recommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.settings = JSON.parse(this.element.getAttribute("data-settings"));
    this.atc = new AddToCart(this.element);

    this.initSwiper();
    if (this.settings.use_recommendations) this.initRecommendations();
  }

  disconnectedCallback() {
    this.atc.destroy();
    this.swiper?.destroy();
  }

  async initRecommendations() {
    const url = this.settings.url;
    if (!url) return;  
    
    try {
      const response = await fetch(url);
      const text = await response.text();

      const tempElement = document.createElement("div");
      tempElement.innerHTML = text;

      this.updateSlider(tempElement);

    } catch (error) {
      console.log(error)
    }
  }

  updateSlider(newRecommSection) {    
    const wrapper = this.element.querySelector(".swiper-wrapper");
    const newChildern = newRecommSection.querySelectorAll(".swiper-slide");

    if (newChildern.length === 0) return;

    wrapper.innerHTML = "";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        newChildern.forEach(child => wrapper.appendChild(child));
      })
    });
  }

  initSwiper() { 
    const swiperElement = this.element.querySelector(".swiper");
    if (!swiperElement) return;

    const settings = JSON.parse(swiperElement.dataset.swiperSettings);

    const isDesktop = new Responsive().matchesBreakpoint("lap_and_up");
    const additionalClass = isDesktop ? ".recommendations__button-container-desktop " : ".recommendations__button-container-mobile ";

    settings.navigation.nextEl = additionalClass + settings.navigation.nextEl;
    settings.navigation.prevEl = additionalClass + settings.navigation.prevEl;    

    swiperElement.dataset.swiperSettings = JSON.stringify(settings);
    
    this.swiper = new RevolutionSwiper(swiperElement);
  }
}

customElements.define("recommendations-section", Recommendations);